<template>
<div>
<mu-table :showCheckbox="false" 
    style="border: 1px solid #e1e8e9;">
    <mu-thead>
        <mu-tr>
            <mu-th class="pointer">Code</mu-th>
            <mu-th class="pointer">Scanné</mu-th>
            <mu-th class="medium-hide">Valider</mu-th>
        </mu-tr>
    </mu-thead>
    <mu-tbody>
        <mu-tr v-for="(item, index) in barcodeTb" 
            :key="index" v-bind:class="{ 'bg-light-green100': item[1] }">
            <mu-td>{{item[0]}}</mu-td>
            <mu-td>{{item[1]}}</mu-td>
            <mu-td>
                <mu-flat-button v-if="!item[1]" icon="done" @click="scanControl([ item[0] ])"/>
                <mu-flat-button v-if="item[1]" icon="not_interested" @click="scanControl([ item[0] ], true)"/>
            </mu-td>
        </mu-tr>
    </mu-tbody>
</mu-table>
</div>
</template>

<script>
import icon       from 'muse-components/icon'
import iconButton from 'muse-components/iconButton'
import {table, thead, tbody, tfoot, tr, td, th }    from 'muse-components/table'
import {col, row} from 'muse-components/grid'
import flatButton from 'muse-components/flatButton'

export default {
    name: 'scan-barcode',
    props: ['cbtable', 'scanMode', 'modeData', 'scanControl'],
    data: function () {
        return {
            pref: this.$auth.userPref //,barcodeTb: this.cbtable[this.modeData.fk_soc]['vouch'][this.modeData.recref]['barcode']
        }
    },
    computed: {
        barcodeTb : function() {
            var sortable = []
            var isScan    = 0
            for (var codeB in this.cbtable[this.modeData.fk_soc]['vouch'][this.modeData.recref]['barcode']) {
                isScan = parseInt(this.cbtable[this.modeData.fk_soc]['vouch'][this.modeData.recref]['barcode'][codeB])
                sortable.push([ codeB, isScan ])
            }
            sortable.sort(function(a, b) {
                return a[1] - b[1]
            })
            return sortable
        }
    },
    mounted: function() {},
    methods: {

    },
    components: {
        'mu-icon': icon,
        'mu-icon-button': iconButton,
        'mu-table': table, 'mu-thead': thead, 'mu-tbody': tbody, 'mu-tfoot': tfoot,
        'mu-tr': tr, 'mu-td': td, 'mu-th': th,
        'mu-flat-button': flatButton
    }
}
</script>

<style lang="less">
@media only screen and (max-width : 768px) {
    .medium-hide {
        display: none;
    }
}
</style>


// WEBPACK FOOTER //
// Scan_barcode.vue?100a050f